import { makeStyles } from 'tss-react/mui';
import { PRODUCT_DETAILS_SCROLL_HEADER_HEIGHT } from '../components/ProductDetailsScrollHeader/productDetailsScrollHeader.styles';

const GROUP_DIVIDER_HEIGHT = 0.5;
const MUI_DIVIDER_BORDER_WIDTH = 1;
const GROUP_DIVIDER_MARGIN = 12;

const GROUP_DIVIDER_ZONE =
  GROUP_DIVIDER_HEIGHT + MUI_DIVIDER_BORDER_WIDTH + GROUP_DIVIDER_MARGIN * 2;

const useProductDetailsListComponentsStyles = makeStyles()((theme) => ({
  fixedHeader: {
    display: 'flex',
    flexDirection: 'column',
    '& #product-details-header-group': {
      backgroundColor: theme.palette.background.paper,
    },
    [theme.breakpoints.up('md')]: {
      '& #product-details-header-group[data-first-group="false"]': {
        marginTop: -GROUP_DIVIDER_ZONE,
      },
      '& #product-details-header-group-divider': {
        visibility: 'hidden',
      },
    },
  },
  groupHeader: {
    backgroundColor: theme.palette.background.paper,
    padding: `10px 0px`,
    top: PRODUCT_DETAILS_SCROLL_HEADER_HEIGHT,
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1.25, 1.5),
    },
    [theme.breakpoints.up('md')]: {
      '&[data-first-group="false"]': {
        top: PRODUCT_DETAILS_SCROLL_HEADER_HEIGHT - GROUP_DIVIDER_ZONE,
      },
    },
  },
  hideGroupDivider: {
    display: 'none',
  },
  groupDivider: {
    height: GROUP_DIVIDER_HEIGHT + MUI_DIVIDER_BORDER_WIDTH,
    backgroundColor: theme.palette.divider,
    [theme.breakpoints.down('sm')]: {
      marginInline: theme.spacing(-1.5),
    },
    [theme.breakpoints.up('md')]: {
      margin: `${GROUP_DIVIDER_MARGIN}px 0px`,
    },
    [theme.breakpoints.between('sm', 'lg')]: {
      margin: `${GROUP_DIVIDER_MARGIN}px 0px ${GROUP_DIVIDER_MARGIN}px 0px`,
    },
  },
}));

export default useProductDetailsListComponentsStyles;
